﻿import browserBack from './lib/browserBack.js';
import ContentPopup from './lib/content-popup';
import FormValidationSimple from './lib/form-validation-simple';
import Select from './lib/select';
import Tooltips from './lib/tooltips';
import Steps from './lib/steps';
import Accordion from './lib/accordion';

class App {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $body: $('body'),
            $agreeinfo1: $("[data-validator-id='agree-info-1']"),
            $formpost: false
        };

        this.init();
    }

    init() {
        new browserBack();
        new ContentPopup();
        new FormValidationSimple();
        new Select();
        new Tooltips();
        new Steps();
        new Accordion();
        this.VasPopup();
        this.VasSubmit();
        this.VasClosePopup();
        this.DelaySubmit();
        //this.AppValiditySubmit();

        this.saveNachwileProductDetails();
        this.HideAnalyticsField()
    }

    VasPopup() {
        let thisDom = this.dom;
        $('body').on('click', '.vas-btn-popup', (e) => {
            if (thisDom.$formpost || $("[data-validator-id='agree-info-1']").prop('checked') || $('#vaseligible').val() == "0") { return true };
            $('.vas-btn-popup').attr('type', '').prop('disabled', true);
            $('.vas-btn-popup').prop('disabled', true);
            if ($('form').valid()) {
                e.preventDefault();
                $('.vas-popup').show();
                $('.vas-btn-popup').attr('type', '').prop('disabled', false);
                //$('.vas-btn-popup').prop('disabled', false);
            }
            else { $('.vas-btn-popup').prop('disabled', false); return true; }
        });
    }

    DelaySubmit() {
        $('body').on('click', '.tmxsubmit', (e) => {
            let thisDom = this.dom;
            if (thisDom.$formpost) { return true };
            if ($('form').valid()) {
                e.preventDefault();
                setTimeout(() => {
                    cLog('done submit delay')
                    $('.loading-sceen').hide();
                    thisDom.$formpost = true;
                    $('.tmxsubmit').click();
                }, 5000);
                $('.loading-sceen').show();
                cLog('start submit delay')
                return true;
            }
            else
                return true;
        });
    }

    VasSubmit() {
        let thisDom = this.dom;
        $('body').on('click', '.vas-submit', (e) => {
            $('.vas-btn-popup').prop('disabled', false);
            if ($('form').valid()) {
                $('.vas-btn-popup').attr('type', 'submit');
                thisDom.$formpost = true;
                if ($("input[name='agree-info-1']").prop('checked')) {
                    $("[data-validator-id='agree-info-1']").prop('checked', true)
                }
                $('.vas-btn-popup').click();
            }
        });

    }
    VasClosePopup() {
        let thisDom = this.dom;
        $('body').on('click', '.vas-close-popup', (e) => {
            $('.vas-btn-popup').prop('disabled', false);
            $('.vas-btn-popup').attr('type', 'submit');
            return true;
        });
    }

    saveNachwileProductDetails() {
        var hasProductDetailsFromSession = false;
        getAjaxData("/scapi/usercalcstatus", "GET", false, null, getSessionDataCallBack);

        function getSessionDataCallBack(cbData, status) {
            if (JSON.parse(cbData).Output != null) {
                hasProductDetailsFromSession = JSON.parse(cbData).Output.Amount == 0 ? false : true;
            }
        }

        if (!hasProductDetailsFromSession) {
            var productDetails = JSON.parse(JSON.stringify(getQueryString($(location).attr('href'))));

            var productType = (productDetails.product != null) ? productDetails.product.toLowerCase() : '';
            if (productType == "stl61_free") {
                let sessionDataInput = {
                    "Amount": productDetails.amount,
                    "Period": productDetails.period,
                    "ProductCalculator": productDetails.productcalculator,
                    "PricingTier": productDetails.pricingtier,
                    "IsBallonProduct": productDetails.isballonproduct,
                    "ProductClassification": productDetails.productclassification,
                    "ProductTermType": productDetails.producttermtype,
                    "ProductElectonicallyCollected": productDetails.productelectonicallycollected,
                    "ProductElectonicallyIssued": productDetails.productelectonicallyissued,
                    "ProductWithInsurance": productDetails.productwithinsurance,
                    "PromotionType": productDetails.promotiontype,
                    "InterestRate": productDetails.interestrate,
                    "TotalInterest": productDetails.totalinterest,
                    "IsInsuranceChecked": productDetails.productcalculator
                }

                //Save calculator data in session
                getAjaxData("/scapi/usercalcstatus", "POST", false, sessionDataInput, postSessionDataCallBack);

                function postSessionDataCallBack(cbData, status) {
                    cLog('push: ' + JSON.stringify(sessionDataInput));
                }
            }

            function getQueryString(url) {
                const queryStr = url.split('?')[1];
                const params = {};

                if (queryStr) {
                    const queryStrPairs = queryStr.split('&');
                    for (const pair of queryStrPairs) {
                        const [key, value] = pair.split('=');
                        params[key] = decodeURIComponent(value
                            .replace(/\+/g, ' '));
                    }
                }
                return params;
            }
        }
    }

    HideAnalyticsField() {
        $('input.AnalyticsData').closest('.form-row').hide();
    }
}

document.addEventListener('DOMContentLoaded', () => new App());